import * as React from "react";
import { WrapperLess } from "../../../components/generic";

interface OwnProps {
}

export const SpeakerGuidelines: React.SFC<OwnProps> = (props) => {
    return <WrapperLess>
        <p><strong>When developing my presentation:</strong></p>
        <ol>
            <li>
                The content and/or presentation with which I am involved will promote quality or improvements
                in healthcare and will not promote a specific proprietary business interest of a commercial interest.
            </li>
            <li>
                If my presentation includes recommendations involving clinical medicine, the recommendations will be
                based on evidence that is accepted within the profession of medicine as adequate justification for their
                indications and contraindications in the care of patients.
            </li>
            <li>
                Any scientific research referred to, reported, or used in support or justification of a patient care
                recommendation will conform to the generally accepted standards of experimental design, data collection and analysis.
            </li>
            <li>
                If my presentation includes a discussion specific health care products or services, I will use generic or
                compound names (to the extent possible). Trade names can be used when it is in the best interest of the learners
                and patients. In such cases, I will trade names from several companies, when possible.
            </li>
            <li>
                If I have been trained or utilized by a commercial entity or its agent as a speaker (e.g., speaker&rsquo;s bureau) for any
                commercial interest, the promotional aspects of that presentation will not be included in any way with this activity.
            </li>
            <li>
                I have obtained, or will obtain, all permissions, as needed, for content that I did not personally develop.
            </li>
        </ol>

        <p><strong>Prior to the Annual Meeting and Onsite Prior to my Presentation:</strong></p>
        <ol>
            <li>
                I will provide my educational content in advance of the meeting, but no later than 20 hours prior to the start time of my
                presentation. I understand that failure to comply with the 20 hour deadline may result in disqualification from future ASRS
                Annual Meeting presentations. NOTE: in some circumstances the deadline is sooner than 20 hours in advance of the presentation; speakers
                must adhere to deadlines provided by ASRS.
            </li>
            <li>
                I understand that the ASRS will review my presentation and/or content prior to the activity to ensure my presentation
                is fair and balanced and free of commercial bias. &nbsp;I will make appropriate changes if required.
            </li>
            <li>
                I understand I have access to the criteria ASRS will use to review my presentation/content by downloading a
                copy of the <a href="https://www.asrs.org/content/documents/asrs-2021-slide-review-template.pdf">Slide Review Form</a>.
            </li>
            <li>
                Onsite, I understand I must check in at the Speaker-Ready Room at least 20 hours prior to my scheduled
                presentation time (or as per the required ASRS deadline).
            </li>
        </ol>

        <p><strong>During my presentation:</strong></p>
        <ol>
            <li>
                At the onset of the presentation, I agree to verbally disclose to the audience all relevant financial relationships
                and to include a disclosure slide at the start of my presentation.
            </li>
            <li>
                I will disclose whether or not data from human research is presented, including IRB status, if applicable. I
                understand this information will be published in the abstracts provided to all attendees.
            </li>
            <li>
                If I am discussing a product that is off-label, I will disclose that the use or indication in question
                is not currently approved by the FDA for labeling or advertising.
            </li>
            <li>
                I understand that all presentations given in the general session will be made from
                ASRS supplied computers and that personal laptops are not allowed.
            </li>
        </ol>

        <p><strong>Other:</strong></p>
        <ol>
            <li>
                I understand that my disclosure will be printed in the final program materials provided to the learners on-site.
            </li>
            <li>
                For my faculty involvement in the ASRS scientific program, I have not or will not accept any
                honoraria, additional payments, or reimbursements from commercial interests.
            </li>
        </ol>

        <h3><strong>Faculty Agreement</strong></h3>
        <p>
            I understand that failure to comply with any or all of the above, particularly to the presentation of fair and balanced information for learners, and
            including adherence to deadlines, may result in the withdrawal of this or future activity participation as determined by the related Education Committee.
        </p>
    </WrapperLess>;
};



// WEBPACK FOOTER //
// ./src/containers/abstracts/components/SpeakerGuidelines.tsx